import { Routes, Route } from 'react-router-dom';
import { useEffect } from 'react';
import WebApp from '@twa-dev/sdk';
import { useUserStore } from './stores/userStore';
import { useLanguage } from './hooks/useLanguage';
import { Navigation } from './components/Navigation';
import { HomePage } from './pages/HomePage';
import { TasksPage } from './pages/TasksPage';
import { TaskDetailPage } from './pages/TaskDetailPage';
import { ProfilePage } from './pages/ProfilePage';
import { WalletPage } from './pages/WalletPage';
import { LeaderboardPage } from './pages/LeaderboardPage';

export default function App() {
  const { initUser, isLoading, setNotLoading } = useUserStore();
  const { isRtl } = useLanguage();

  useEffect(() => {
    // Initialize user from Telegram data
    const tgUser = WebApp.initDataUnsafe.user;
    if (tgUser) {
      initUser({
        telegram_id: tgUser.id.toString(),
        first_name: tgUser.first_name,
        last_name: tgUser.last_name,
        username: tgUser.username,
      });
    } else {
      // No Telegram user data - stop loading
      console.error('No Telegram user data available');
      setNotLoading();
    }

    // Set header color
    try {
      WebApp.setHeaderColor('secondary_bg_color');
      WebApp.setBackgroundColor('secondary_bg_color');
    } catch (e) {
      // Ignore if not in Telegram context
    }
  }, [initUser, setNotLoading]);

  // Set RTL direction on document
  useEffect(() => {
    document.documentElement.dir = isRtl ? 'rtl' : 'ltr';
    document.documentElement.lang = isRtl ? 'ar' : 'en';
  }, [isRtl]);

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-screen bg-tg">
        <div className="animate-spin w-10 h-10 border-3 border-tg-hint border-t-brand-primary rounded-full" />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-tg-secondary pb-safe">
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/tasks" element={<TasksPage />} />
        <Route path="/tasks/:id" element={<TaskDetailPage />} />
        <Route path="/profile" element={<ProfilePage />} />
        <Route path="/wallet" element={<WalletPage />} />
        <Route path="/leaderboard" element={<LeaderboardPage />} />
      </Routes>
      <Navigation />
    </div>
  );
}
